function buildAccountSavePatch(account) {
    return {
        name: account.name,
        address1: account.address1,
        address2: account.address2,
        postcode: account.postcode,
        country: account.country,
        type: account.type,
        trialPeriod: account.trialPeriod,
        accountVerified: account.accountVerified,
        enabled: account.enabled,
        alpha: account.alpha,
        beta: account.beta,
        customApps: account.customApps,
        codePinPairing: account.codePinPairing,
        subscriptions: account.subscriptions,
        startDate: account.startDate,
    };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildAccountSavePatch: buildAccountSavePatch,
    };
}

if (typeof angular !== 'undefined') {
(function (module) {
    'use strict';

    function AdminViewAccountCtrl(Account, $stateParams, Includes, Store, $state, $rootScope, utils) {
        this.$onInit = () => {
            Account
                .findById({ id: $stateParams.accountId, filter: Includes.accounts })
                .$promise
                .then((response) => {
                    this.account = Store.setSingleModelData('accounts', response.id, response);
                });
            this.selectedIndex = $rootScope.selectedIndex;
            this.currentUser = Store.getCurrentUser();

        };
        this.cancel = () => {
            $state.go('root.admin.accounts');
        };
        this.addUser = () => {
            $rootScope.selectedIndex = 1;
            $state.go('root.admin.accounts.view.adduser');
        };
        this.inviteUser = () => {
            $rootScope.selectedIndex = 1;
            $state.go('root.admin.accounts.view.inviteuser');
        };
        this.goBack = () => {
            $rootScope.selectedIndex = 0;
            $state.go('root.admin.accounts');
        };
        this.checkType = () => {
            if (this.account.type === 'paid') {
                this.account.startDate = new Date();
            }
            if (this.account.type === 'free') {
                this.account.startDate = null;
            }
        };

        this.saveAccount = () => {
            $rootScope.selectedIndex = 0;
            Account
                .prototype$patchAttributes(
                    { id: this.account.id },
                    buildAccountSavePatch(this.account),
                )
                .$promise
                .then(() => {
                    return Account.findById({
                        id: this.account.id,
                        filter: Includes.accounts,
                    }).$promise;
                })
                .then((account) => {
                    return Store.setSingleModelData('accounts', this.account.id, account);
                })
                .then(() => {
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });

        };

    }

    module
        .component('adminViewAccountComponent', {
            templateUrl: '/js/admin/accounts/view-account/view-account.html',
            controller: AdminViewAccountCtrl,
        })
        .config(($stateProvider) => {
                $stateProvider
                    .state('root.admin.accounts.view', {
                        url: '/:accountId',
                        data: {
                            pageTitle: 'ADMIN_ACCOUNTS_VIEW.PAGE_TITLE',
                        },
                        views: {
                            'content@root': {
                                template: '<admin-view-account-component />',
                            },
                        },
                    });
            },
        );

})(angular.module('rocket.components'));
}
